@use 'themes/westfield' as *;
@use 'tools/dirg' as *;

.form {
  > * + * {
    margin: 0;
  }
}

.descriptionRow {
  margin: units(1) 0 units(1.5);
}
